/**
 * 加载图片
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useContext, useMemo } from "react";

import "./index.less";
import { SysChatMessage } from "@/types/chat";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import { isEqualEmployee } from "@/utils/chat/message";
import { duccConfigI18 } from "@/utils/i18n";
import { NetState } from "@/models/netStatus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { isGroupCleanMessage } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import Bus from "@/utils/bus";

interface SysProps {
  message: SysChatMessage;
}

type IProps = Readonly<SysProps & ChatState & NetState>;

function SysMessage(props: IProps) {
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { joyspaceHost } = appRuntimeEnv;
  const { message, currentEmployee, selectedSession, newPublicResult } = props;
  // console.log('SysMessage', message);
  const { t } = useTranslation("chat");

  const tipContent = useMemo(() => {
    if (message.flag === 1) {
      // 0-直接显示content,1-文件下载（需要拼接content），2-接收红包消息（需要拼接content）
      const receiver = isEqualEmployee(message.sender, currentEmployee) ? `您` : message.nickName;
      return t("receive-file-tip", { receiver, filename: message.content });
    }
    if (message.flag === 32) {
      const fileName = message?.fileName;
      const fileId = message?.content;
      const transferUrl = `${joyspaceHost}/transferResult?transferCode=${fileId}`;
      return (
        <div style={{ display: "flex", whiteSpace: "nowrap", overflow: "hidden" }}>
          您转存了文件
          <span
            style={{
              color: "#232930",
              fontWeight: "normal",
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: 200
            }}
          >
            {fileName}
          </span>
          <span
            onClick={() => {
              window.open(transferUrl);
            }}
          >
            查看云文件
          </span>
        </div>
      );
    } else if (message.flag === 99) {
      return (
        <div style={{ display: "flex", whiteSpace: "nowrap", overflow: "hidden" }}>
          已将
          <p className="ellipsis" style={{ marginLeft: "2px" }}>
            {message.name as any}
          </p>
          转存到 {duccConfigI18.joyspace}-我的文件
        </div>
      );
    } else if (message.flag === 3) {
      const receiver = isEqualEmployee(message.sender, currentEmployee) ? `您` : message.nickName;
      return `${receiver}${message.content}`;
    } else if (isGroupCleanMessage(message)) {
      return (
        <>
          <span className="text">{message.content}</span>
          <span className="action" onClick={() => Bus.emit("recordClean:open")}>
            查看详情
          </span>
        </>
      );
    } else {
      return message.content;
    }
  }, [
    message.flag,
    message.sender,
    message.nickName,
    message.content,
    message?.fileName,
    message.name,
    currentEmployee,
    t,
    joyspaceHost
  ]);

  return message.flag === 11010 ? (
    <div className="message-time-line">
      <div className="line left-line" />
      <div className="sys-message-box">{tipContent}</div>
      <div className="line right-line" />
    </div>
  ) : (
    <div className="sys-message-box">{tipContent}</div>
  );
}

function mapStateToProps({ chat, netStatus }: any) {
  const { currentEmployee, selectedSession } = chat as ChatState;
  const { newPublicResult } = netStatus;
  return { currentEmployee, selectedSession, newPublicResult };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SysMessage);
